// extracted by mini-css-extract-plugin
export var boxItems = "_bm-1";
export var boxItemsLg = "_bm-2";
export var button = "_bm-7";
export var buttonLg = "_bm-8";
export var filterGroupBox = "_bm-0";
export var icon = "_bm-3";
export var iconSecondary = "_bm-6";
export var iconWrapper = "_bm-4";
export var iconWrapperLg = "_bm-5";